export const AI_INSIGHTS_REDUCER_KEY = 'aiInsightsStore';

export type PromptType = 'spending' | 'investments' | 'investmentsWhy';

// Request/Response types
export interface AiPromptRequestData {
  userPrompt: {
    text?: string;
  };
  agent: string;
  overrideSystemPrompt?: string;
  context: { [key: string]: any };
  outputSchema: any;
  options: any;
  cacheKey?: string;
}

export interface AiPromptResponse {
  assistantResponse: string;
  history?: any[];
  finalResponse: boolean;
}

// Prompt configuration
export interface PromptConfig {
  id: string;
  name: string;
  type: PromptType;
  prompt: string;
  contextPrefix: string;
  includeData: boolean;
  schema?: any;
  enableWebSearch?: boolean;
}

export interface PromptResult {
  id: string;
  data: string | null;
  parsedData?: any;
  isLoading: boolean;
  error: string | null;
  lastUpdated: string | null;
}

export interface AiInsightsState {
  prompts: Record<string, PromptConfig>;
  results: Record<string, PromptResult>;
}

// Factory function for creating AI prompt requests
export const createAiPromptRequest = (props: Partial<AiPromptRequestData>): AiPromptRequestData => ({
  userPrompt: props.userPrompt || { text: '' },
  agent: props.agent ?? '',
  // The gateway replaces the agent's system prompt with any non-null override, even ''.
  overrideSystemPrompt: props.overrideSystemPrompt || undefined,
  context: props.context || {},
  outputSchema: props.outputSchema || {},
  options: props.options,
  cacheKey: props.cacheKey,
});

declare module 'app-components/utils/redux-store/rootState' {
  export default interface RootState {
    [AI_INSIGHTS_REDUCER_KEY]: AiInsightsState;
  }
}
